import { TeamsProvider } from "./teams/TeamsProvider";
import { DataProvider, useData } from "./data/DataProvider";
import { useRoute } from "./lib/nav";
import { ConfigPage } from "./pages/ConfigPage";
import { NonAutorizzato } from "./pages/NonAutorizzato";
import { ElencoGare } from "./pages/ElencoGare";
import { ElencoAlbi } from "./pages/ElencoAlbi";
import { Welcome } from "./pages/Welcome";
import { SchedaGara } from "./pages/SchedaGara";
import { ModificaGara } from "./pages/ModificaGara";
import { CreaCartelle } from "./pages/CreaCartelle";
import { Servizi } from "./pages/Servizi";
import { Report } from "./pages/Report";
import { Checklist } from "./pages/Checklist";
import { ModelloChecklist } from "./pages/ModelloChecklist";

/**
 * Punti di ingresso (percorso dell'URL):
 *   /config → configurazione della scheda di canale
 *   /tab    → scheda di canale
 *   /app    → app personale
 *   /       → come /app (sviluppo nel browser)
 */
export function App() {
  const path = window.location.pathname.replace(/\/$/, "");
  return (
    <TeamsProvider>
      {path === "/config" ? (
        <ConfigPage />
      ) : (
        <DataProvider>
          <Router />
        </DataProvider>
      )}
    </TeamsProvider>
  );
}

function Router() {
  const { roles } = useData();
  const route = useRoute();
  if (!roles.gestore && !roles.collaboratore && !roles.lettore) return <NonAutorizzato />;

  // Le schermate di modifica sono solo per i gestori
  const gestore = roles.gestore;
  switch (route.name) {
    case "gara":
      return <SchedaGara id={route.id} />;
    case "gare":
      return <ElencoGare vista={route.vista} filtro={route.filtro} />;
    case "nuova":
      return gestore ? <ModificaGara /> : <Welcome />;
    case "nuovo-albo":
      return gestore ? <ModificaGara tipo="Albo" /> : <Welcome />;
    case "albi":
      return <ElencoAlbi archiviati={route.archiviati} />;
    case "modifica":
      return gestore ? <ModificaGara id={route.id} /> : <SchedaGara id={route.id} />;
    case "cartelle":
      return gestore ? <CreaCartelle id={route.id} /> : <SchedaGara id={route.id} />;
    case "report":
      // Report: gestori e collaboratori (i lettori per ora no)
      return gestore || roles.collaboratore ? <Report /> : <Welcome />;
    case "checklist":
      return <Checklist id={route.id} />;
    case "modello-checklist":
      return gestore ? <ModelloChecklist /> : <Welcome />;
    case "servizi":
      return gestore ? <Servizi /> : <Welcome />;
    default:
      return <Welcome />;
  }
}
